import MasterSerive from "./MasterService";

const InsuranceService = {
    ...MasterSerive,

    getFormConfig() {
        return this.get('/agency/api/formconfig')
    },
    getMasterConfig() {
        return this.get('agency/api/masterConfig')
    },
    getAddonList(params: object) {
        return this.post('agency/api/getAddOn', params)
    },

    getLeadList(params: object) {
        return this.post('agency/api/leadList', params)
    },

    getClaimList(params: object) {
        return this.post('agency/api/claimList', params)
    },

    RaiseClaim(params: object) {
        return this.post('agency/api/raiseClaim', params)
    },
    bulkPayment(params: object) {
        return this.post('agency/api/bulkPayment', params)
    },
    paymentProofDocs(params: object) {
        return this.post('/payment/paymentProofDocs', params) 
    },
    getLeadPaymentDetails(params: object) {
        return this.post('agency/api/getLeadPaymentDetails', params) 
    },
    getQuoteDetail(params: object) {
        return this.post('agency/api/leadQuoteDetails', params) 
    },

    getPartnerList(params: any) {
        return this.post('/agency/api/getPartner', params)
    },

    getAddonDetails(params: any) {
        return this.post('/agency/api/getAddonDetails', params)
    },

    createAgencyLead(params: any) {
        return this.post('/agency/api/createAgencyLead', params)
    },
    raisedSoa(params: object) {
        return this.post('agency/api/raiseSoa', params) 
    },
    getPartnerInfo(){
        return this.get('/agency/api/insurancePartnerInfo');
    },
    getLeadDetails(params: any) {
        return this.post('/lead/leadDetails', params)
    },
    updateDocStatus(params: any) {
        return this.post('/lead/updateDocStatus', params)
    },
    downloadAllPolicies(params: object) {
        return this.post('agency/api/downloadPolicy', params) 
    },
    generateDocUrls(params: object) {
        return this.post('agency/api/uploadLeadDocImages', params) 
    },
    getMappingAgencyList(params: object) {
        return this.post('/agencySalesUser/getMappingAgencyList', params) 
    },
    loginAgency(params: object){
      return this.post('/agency/auth/loginAgency', params)  
    },
    // Lead APis
    getLeadListID(params: object) {
        return this.post('/lead/leadList', params)
    },

    getDashboardListingID(params: any) {
        return this.post('/agency/dashboardList', params)
    },
    savePaymentInfo(params: any){
      return this.post('/lead/savePaymentInfo', params)  
    },

   // addonList
   getaddonListID(params: object) {
        return this.post('/addOn/addonList', params)
    },
    // insurerList 
    insurerListID(params: object) {
        return this.post('/addOn/insurerList', params)
    },
    // addonDetailsData 
   getAddonDetailsDataID(params: object) {
        return this.post('/crm/api/getAddonDetailsData', params)
   },
    
    getAddonDetailsID(params: object) {
        return this.post('/addon/insurerList', params)
    },
    createAgencyLeadID(params: any) {
        return this.post('/lead/createAgencyLead', params)
    },
    paymentGenerateData(params: any) {
        return this.post('/xendit/payment', params)
    },
    generatePaymentLinkUrl(params: any) {
        return this.post('/xendit/generate-url', params)
    },
    saveAdditionalDiscount(params: any) {
        return this.post('/lead/saveAdditionalDiscount', params)
    },
    getAdditionalDiscount(params: any) {
        return this.post('/lead/getAdditionalDiscount', params)
    },
    insurerListByLeadId(params: object) {
        return this.post('/addOn/insurerListByleadId', params)
    },
    backorderSampleFiles(params: any) {
        return this.post('/lead/backorderSampleFiles', params)
    },
    backorderApplicationDocUpload(params: any) {
        return this.post('/lead/backorderAgentDocUpload', params)
    },
    fetchAllDocuments(params: any) {
        return this.post('/lead/fetchAllDocuments', params)
    },
}

export default InsuranceService;
